import { Trans, useLingui } from "@lingui/react/macro";
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { apiPostAuthTokenLogin } from "../../../api";
import { RequestError } from "../../../api/api-connector";
import { genericErrorMsg } from "../../../app/common-messages";
import { ErrorMessage } from "../../../components/ui-kit/error-message";
import { Spinner } from "../../../components/ui-kit/spinner";

export function TokenLoginRoute() {
  const { t } = useLingui();
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    const expiryToken = searchParams.get("expiry_token");

    if (!token || !expiryToken) {
      setErrorMessage(t`Invalid login link. Missing token parameters.`);
      return;
    }

    void apiPostAuthTokenLogin({
      body: { token, expiry_token: expiryToken },
      meta: { ignore401: true },
    })
      .then(() => {
        window.location.href = "/";
      })
      .catch((error) => {
        if (error instanceof RequestError) {
          if (error.response.status === 406) {
            setErrorMessage(
              t`This login link is invalid, expired, or has already been used.`,
            );
          } else {
            setErrorMessage(t(genericErrorMsg));
          }
        } else {
          throw error;
        }
      });
  }, [searchParams, t]);

  return (
    <div className="grow flex items-center justify-center">
      <div className="flex flex-col w-80 items-center">
        {errorMessage ? (
          <>
            <ErrorMessage message={errorMessage} />
            <div className="mt-6">
              <Link
                to="/login"
                className="text-xs text-brand-primary hover:underline"
              >
                <Trans>Back to login</Trans>
              </Link>
            </div>
          </>
        ) : (
          <>
            <Spinner size={32} />
            <p className="text-muted-foreground mt-4 text-sm">
              <Trans>Logging in...</Trans>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
